import React from 'react';
import Select from 'react-select';

export default class StoreAdder extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            selectedStore: null
        };

        this.getStoreOptions = this.getStoreOptions.bind(this);
        this.addStoreToModule = this.addStoreToModule.bind(this);
        this.selectStore = this.selectStore.bind(this);
    }

    getStoreOptions() {
        return this.props.stores.map((store) => {
            return {value: store.gln, label: `${store.gln} - ${store.retailer.name}, ${store.city}`}
        });
    }

    addStoreToModule() {
        if (!this.state.selectedStore) return;
        this.props.onAdd(this.state.selectedStore.value, this.props.module);
        this.setState({selectedStore: null});
    }

    selectStore(store) {
        this.setState({selectedStore: store});
    }

    render() {
        return (
            <div>
                <div style={{width: '60%', float: 'left'}}>
                    <Select name="form-field-name"
                            value={this.state.selectedStore}
                            onChange={this.selectStore}
                            options={this.getStoreOptions()}
                    />


                </div>
                <div style={{width: '40%', float: 'left'}}>
                    <button className="btn btn-primary"
                            onClick={this.addStoreToModule}>
                        zu Modul hinzufügen
                    </button>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/admin/module/overview/StoreAdder.js